import { IconButton, makeStyles, Grid, Button } from '@material-ui/core';
import TocIcon from '@material-ui/icons/Toc';
import HeaderModal from "../../../global/headerModal";
import ModalBase from "./../../../global/ModalBase";
import { useState } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { useSelector } from 'react-redux';
import { formatDinero } from "./../../../utils/formatDinero"
export const ModalStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
    },
    containerSpacing: {
        margin: "10px 0",
    },
    modalBotones: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    modalBotonesCenter: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    modalBoton: {
        margin: "1px 0",
        width: "20%",
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        maxWidth: "900px",
        margin: "0 auto",
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "none",
        boxShadow: theme.shadows[10],
        padding: theme.spacing(1, 2, 1),
        maxWidth: "900px",
        minWidth: "500px",
    },
}));

const DetallePagoGrupo = () => {
    const classes = ModalStyles()
    const [open, setOpen] = useState(false)
    const { ItemsPagarGrupo } = useSelector((store) => store.calendario);
    const handleClose = () => {
        setOpen(false)
    }
    const handleOpen = () => {
        setOpen(true)
    }
    return (
        <div>
            <IconButton onClick={handleOpen}>
                <TocIcon color="primary" />
            </IconButton>

            <ModalBase classes={classes} open={open} onClose={handleClose}>
                <HeaderModal
                    handleClose={handleClose}
                    titulo="Grupo"
                />
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12}>
                        <div style={{ textAlign: "center" }}>
                            <h3>Numero de referencias a pagar: {ItemsPagarGrupo.compras?.length}</h3>
                        </div>
                        <div style={{ textAlign: "center" }} >
                            <h3>Total a Pagar: {formatDinero(ItemsPagarGrupo.totalPagar)} {ItemsPagarGrupo.moneda?.Clave}</h3>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <TableContainer style={{ height: 300 }} component={Paper}>
                            <Table className={classes.table} stickyHeader aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">Referencia</TableCell>
                                        <TableCell align="center">Monto</TableCell>
                                        <TableCell align="center">Moneda</TableCell>
                                        <TableCell align="center">No. Pax</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {ItemsPagarGrupo.compras.map((row) => (
                                        <TableRow hover key={row.idCompra}>
                                            <TableCell align="center">{row.cuenta?.Meta?.Referencia}</TableCell>
                                            <TableCell align="center">{formatDinero(row.MontoProveedor)}</TableCell>
                                            <TableCell align="center">{row.moneda?.Clave}</TableCell>
                                            <TableCell align="center">{row.paquete?.Numero_Personas}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12} className={classes.modalBotonesCenter}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={classes.modalBoton}
                            onClick={handleClose}
                        >
                            Aceptar
                        </Button>
                    </Grid>
                </Grid>
            </ModalBase>
        </div>
    )
}
export default DetallePagoGrupo